import { createContext, useContext, useEffect, useState } from "react";
import { Storage } from "src/services";

type GlobalContextType = {
  isYappUser: boolean;
  setIsYappUser: (isYappUser: boolean) => void;
};

const GlobalContext = createContext<GlobalContextType | undefined>(undefined);

export function GlobalContextProvider({ children }: { children: React.ReactNode }) {
  const [isYappUser, setIsYappUserState] = useState<boolean>(false);

  useEffect(() => {
    setIsYappUserState(Storage.getIsYappUser());
  }, []);

  function setIsYappUser(isYappUser: boolean) {
    setIsYappUserState(isYappUser);
    Storage.setIsYappUser(isYappUser);
  }

  return <GlobalContext.Provider value={{ isYappUser, setIsYappUser }}>{children}</GlobalContext.Provider>;
}

export function useGlobalContext() {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalContext must be used within GlobalContextProvider");
  }
  return context;
}
